import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useMemo, useState } from 'react'

import Layouts from '@/layouts/Layouts'
import { getDetailProfile } from '@/services/sez-regions'
import { BaseRequest } from '@/types/sez-regions'
import { htmlToText, limitText } from '@/utils/formatter'
import { useAppSelector } from '@/utils/hooks'

import HighlightImage from './HighlightImage'
import MainInfo from './MainInfo'
import TabsDetail from './TabsDetail'

const DetailMaps = () => {
  const router = useRouter()
  const { t } = useTranslation()
  const [hitContact, setHitContact] = useState(false)

  useEffect(() => {
    document.body.style.overflow = 'auto'
  }, [])

  const request: BaseRequest = useMemo(() => {
    return {
      params: { slug: String(router.query?.slug) },
      headers: { 'Accept-Language': String(router.locale) },
    }
  }, [])

  const { data } = useAppSelector(getDetailProfile.select(request))

  return (
    <Layouts
      title={String(t('investment:distributionMaps.detail.title'))}
      description={htmlToText(limitText(String(data?.data.description ?? '')))}
    >
      <div className='min-h-screen w-full pt-14 lg:pt-18'>
        <div className='pt-5 lg:pt-6'>
          <HighlightImage />
          <MainInfo setHitContact={setHitContact} />
          <TabsDetail hitContact={{ hitContact, setHitContact }} />
        </div>
      </div>
    </Layouts>
  )
}

export default DetailMaps
